(() => {
  if (window.EgMetalBedGuideVideosLoaded) return;
  window.EgMetalBedGuideVideosLoaded = true;

  const selector = '[data-eg-metal-guide-videos]';

  const activatePanel = (section, key, focusTab = false) => {
    const tabs = section.querySelectorAll('[data-eg-metal-video-tab]');
    const panels = section.querySelectorAll('[data-eg-metal-video-panel]');

    tabs.forEach((tab) => {
      const selected = tab.dataset.videoKey === key;
      tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selected && focusTab) tab.focus({ preventScroll: true });
    });

    panels.forEach((panel) => {
      const selected = panel.dataset.videoKey === key;
      const iframe = panel.querySelector('iframe[data-src]');
      panel.hidden = !selected;

      if (!iframe) return;
      if (selected && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.dataset.src);
      } else if (!selected && iframe.getAttribute('src')) {
        iframe.removeAttribute('src');
      }
    });
  };

  const init = (section) => {
    if (!section || section.dataset.egMetalGuideReady === 'true') return;
    section.dataset.egMetalGuideReady = 'true';

    const tabs = section.querySelectorAll('[data-eg-metal-video-tab]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activatePanel(section, tab.dataset.videoKey));
    });

    const selected = section.querySelector('[data-eg-metal-video-tab][aria-pressed="true"]') || tabs[0];
    if (selected) activatePanel(section, selected.dataset.videoKey);
  };

  document.querySelectorAll(selector).forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.matches(selector) ? event.target : event.target.querySelector(selector));
  });

  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest('[data-eg-metal-video-tab]');
    const panel = event.target.closest('[data-eg-metal-video-panel]');
    const section = event.target.closest(selector);
    if (!section) return;
    if (tab) activatePanel(section, tab.dataset.videoKey, true);
    if (panel) activatePanel(section, panel.dataset.videoKey, true);
  });
})();

(() => {
  if (window.EgMetalBedGuideCardsLoaded) return;
  window.EgMetalBedGuideCardsLoaded = true;

  const selector = '[data-eg-metal-guide-cards]';

  const init = (section) => {
    if (!section || section.dataset.egMetalGuideCardsReady === 'true') return;

    const track = section.querySelector('[data-eg-metal-guide-cards-track]');
    const previousButton = section.querySelector('[data-eg-metal-guide-cards-prev]');
    const nextButton = section.querySelector('[data-eg-metal-guide-cards-next]');

    if (!track || !previousButton || !nextButton) {
      section.dataset.egMetalGuideCardsReady = 'true';
      return;
    }

    section.dataset.egMetalGuideCardsReady = 'true';

    const controller = new AbortController();
    const { signal } = controller;
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(updateControls) : null;
    section.egMetalGuideCardsController = controller;
    section.egMetalGuideCardsResizeObserver = resizeObserver;

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getScrollTargets() {
      const maxScroll = getMaxScroll();
      const trackBounds = track.getBoundingClientRect();
      const targets = Array.from(track.querySelectorAll('.eg-metal-guide-card')).map((card) => {
        const cardBounds = card.getBoundingClientRect();
        const cardStart = cardBounds.left - trackBounds.left + track.scrollLeft;
        return Math.max(0, Math.min(maxScroll, cardStart));
      });

      targets.push(0, maxScroll);
      targets.sort((a, b) => a - b);

      return targets.filter((target, index) => index === 0 || Math.abs(target - targets[index - 1]) > 2);
    }

    function updateControls() {
      const maxScroll = getMaxScroll();
      const currentScroll = Math.max(0, track.scrollLeft);
      const canScroll = maxScroll > 6;

      section.dataset.canScroll = canScroll ? 'true' : 'false';
      previousButton.disabled = !canScroll || currentScroll <= 2;
      nextButton.disabled = !canScroll || currentScroll >= maxScroll - 2;
    }

    const scrollByCard = (direction) => {
      const currentScroll = Math.max(0, track.scrollLeft);
      const targets = getScrollTargets();
      const target = direction > 0
        ? targets.find((position) => position > currentScroll + 2)
        : targets.slice().reverse().find((position) => position < currentScroll - 2);

      track.scrollTo({
        left: target ?? (direction > 0 ? getMaxScroll() : 0),
        behavior: 'smooth',
      });
    };

    previousButton.addEventListener('click', () => scrollByCard(-1), { signal });
    nextButton.addEventListener('click', () => scrollByCard(1), { signal });
    track.addEventListener('scroll', updateControls, { passive: true, signal });
    window.addEventListener('resize', updateControls, { signal });

    track.querySelectorAll('img').forEach((image) => {
      image.addEventListener('load', updateControls, { signal });
    });

    resizeObserver?.observe(track);

    updateControls();
    window.setTimeout(updateControls, 180);
  };

  document.querySelectorAll(selector).forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
    init(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
    if (!section) return;

    section.egMetalGuideCardsController?.abort();
    section.egMetalGuideCardsResizeObserver?.disconnect();
    delete section.egMetalGuideCardsController;
    delete section.egMetalGuideCardsResizeObserver;
    delete section.dataset.egMetalGuideCardsReady;
  });

  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('.eg-metal-guide-card');
    const section = event.target.closest(selector);
    if (!card || !section) return;

    card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
})();
